import img1 from '../../assets/img/home-sec3-sek1.jpg';
import img2 from '../../assets/img/home-sec3-sek2.jpg';
import img3 from '../../assets/img/home-sec3-sek3.jpg';
import img4 from '../../assets/img/home-sec2-sek1.jpg';
import img5 from '../../assets/img/home-sec3-sek4.jpg';
import img6 from '../../assets/img/home-sec3-sek6.jpg';



const homeData = {
    homeData:[
        {
            id: 1,
            img: img1,
            title: "House sofa",
        },
        {
            id: 2,
            img: img2,
            title: "Chair",
        },
        {
            id: 3,
            img: img5,
            title: "Wardrobe",
        },
        {
            id: 4,
            img: img4,
            title: "House sofa",
        },
        {
            id: 5,
            img: img6,
            title: "Wardrobe",
        },{
            id: 6,
            img: img3,
            title: "Chair",
        },
    ]
}  
export default homeData
